import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { ProductLink } from '#app/components/marketing/product-link.tsx'
import routes from '#routes/index.js'

export function TeaserVideoJumbo({
	isIntersectingContent,
}: {
	isIntersectingContent: boolean
}) {
	const { t } = useTranslation('common')
	const videoReference = useRef<HTMLVideoElement>(null)

	useEffect(() => {
		// If the content is intersecting, we pause the video.
		if (isIntersectingContent) {
			videoReference.current?.pause()
		}
		// If the content is not intersecting, we play the video.
		else {
			void videoReference.current?.play()
		}
	}, [isIntersectingContent])

	return (
		<div className="relative h-full w-full">
			{/* Native browser solution: browser picks the right source based on media query */}
			<video
				ref={videoReference}
				controls={false}
				loop
				muted
				autoPlay
				playsInline
				preload="auto"
				className="inset-0 z-0 h-screen w-full object-cover"
			>
				<source
					src="/videos/home-sapienstone-mobile.mp4"
					type="video/mp4"
					media="(max-width: 1023px)"
				/>
				<source
					src="/videos/home-sapienstone-desktop.mp4"
					type="video/mp4"
					media="(min-width: 1024px)"
				/>
			</video>

			<ProductLink
				link={routes.public.products.list.route({})}
				children={t('actions.checkOurProduct')
					.split(' ')
					.map((item: string) => (
						<span key={item}>
							{item}
							<br />
						</span>
					))}
			/>
		</div>
	)
}
